import React, { useCallback, useEffect, useMemo } from 'react'
import Select from 'react-select'
import { Link, useLocation } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { Controller, useForm } from 'react-hook-form'
import { Form } from 'react-bootstrap'
import { getAllCity } from '../../redux/slices/citySlice'
import { formatCustomTrim, isDateAfter, isDateBefore } from '../../helper/function'
import CommonDateTimePicker from '../../component/commonDateTimePicker'

const OverviewFilter = ({ showFilter, setShowFilter, setFilterData, handlePagination }) => {
  const dispatch = useDispatch()
  const collapse = true
  const location = useLocation()
  const { handleSubmit, control, trigger, reset, watch, setValue } = useForm({})
  const { allRegion } = useSelector(({ region }) => region)
  const { allCity } = useSelector(({ city }) => city)
  const { allOverview } = useSelector((state) => state.overView)

  useEffect(() => {
    const params = {
      region_id: watch('region')?.region_id
    }
    dispatch(getAllCity(watch('region')?.region_id && params))
      .then(() => {})
      .catch((err) => {
        console.log('err :>> ', err)
      })
  }, [watch('region')])

  const CleaningStatus = useMemo(
    () => [
      { key: 'CANCELED', label: 'Canceled', backKey: 'canceled' },
      { key: 'SCHEDULED', label: 'Scheduled', backKey: 'scheduled' },
      { key: 'COMPLETED', label: 'Completed', backKey: 'completed' },
      { key: 'IN_PROGRESS', label: 'In Progress', backKey: 'in progress' }
    ],
    []
  )

  const handleFilterclear = useCallback(() => {
    reset({
      created_start: '',
      created_end: '',
      cleaner: '',
      hostname: '',
      region: '',
      city: ''
    })
    setFilterData({})
    setShowFilter(!showFilter)
    handlePagination && handlePagination(1)
  }, [showFilter])

  const onSubmit = useCallback(
    (data) => {
      const booking_status = CleaningStatus.filter((status) => data?.[status.key]).map((status) => status.backKey)
      setFilterData({
        created_start: data?.created_start ? data?.created_start : undefined,
        created_end: data?.created_end ? data?.created_end : undefined,
        cleaner: formatCustomTrim(data?.cleaner),
        hostname: formatCustomTrim(data?.hostname),
        region: data?.region?.region_id,
        city_id: data?.city?.city_id,
        booking_status: booking_status
      })
      handlePagination && handlePagination(1)
      setShowFilter(!showFilter)
    },
    [showFilter]
  )

  return (
    <div className={`toggle-sidebar ${showFilter ? 'open-filter' : ''}`}>
      <div className="sidebar-layout-filter">
        <div className="sidebar-header">
          <h5>Filter</h5>
          <Link
            to="#"
            className="sidebar-closes"
            onClick={() => {
              setShowFilter(!showFilter)
            }}
          >
            <i className="fa-regular fa-circle-xmark" />
          </Link>
        </div>

        <div className="sidebar-body">
          <div className="title">{location?.pathname == '/overview' ? 'Overview' : 'Calendar'}</div>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div
              id="collapseOne"
              className={collapse ? 'collapse show' : 'collapse'}
              aria-labelledby="headingOne"
              data-bs-parent="#accordionExample1"
            >
              <div className="card-body-chat">
                {window.location.pathname == '/overview' && (
                  <div className="row">
                    <label style={{ color: 'black' }}>Date</label>
                    <div className="col-md-12">
                      <div className="form-group">
                        <label>From:</label>
                        <div className="date_picker_main_div">
                          <CommonDateTimePicker
                            name="created_start"
                            control={control}
                            disablePast={false}
                            className="form-control bg-transparent dark_border"
                            placeholder="DD/MM/YYYY"
                            onDateChange={() => {
                              trigger('created_start')
                            }}
                            shouldDisableDate={(date) => isDateAfter(date, watch('created_end'))}
                            type="DatePicker"
                            format="DD/MM/YYYY"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="form-group">
                        <label>To:</label>
                        <div className="date_picker_main_div">
                          <CommonDateTimePicker
                            name="created_end"
                            control={control}
                            disablePast={false}
                            className="form-control bg-transparent dark_border"
                            placeholder="DD/MM/YYYY"
                            onDateChange={() => {
                              trigger('created_end')
                            }}
                            shouldDisableDate={(date) => isDateBefore(date, watch('created_start'))}
                            type="DatePicker"
                            format="DD/MM/YYYY"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                <div className="row">
                  <div className="col-lg-12 col-sm-12">
                    <div className="form-group">
                      <label>Cleaner</label>
                      <Controller
                        name="cleaner"
                        control={control}
                        render={({ field: { value, onChange } }) => (
                          <>
                            <input
                              className="form-control bg-transparent dark_border"
                              autoComplete="off"
                              value={value}
                              type="text"
                              placeholder="Search Cleaner Name"
                              onChange={(val) => {
                                onChange(val)
                                trigger('name')
                              }}
                            />
                          </>
                        )}
                      />
                    </div>
                  </div>
                  <div className="col-lg-12 col-sm-12">
                    <div className="form-group">
                      <label>Host</label>
                      <Controller
                        name="hostname"
                        control={control}
                        render={({ field: { value, onChange } }) => (
                          <>
                            <input
                              className="form-control bg-transparent dark_border"
                              autoComplete="off"
                              value={value}
                              type="text"
                              placeholder="Search Host Name"
                              onChange={(val) => {
                                onChange(val)
                                trigger('name')
                              }}
                            />
                          </>
                        )}
                      />
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-lg-12 col-sm-12">
                    <div className="form-group input_text border-remove dark_border_divs">
                      <label>Region</label>
                      <Controller
                        name="region"
                        control={control}
                        render={({ field }) => (
                          <Select
                            {...field}
                            className={`react-selectcomponent form-control select-box-filed`}
                            getOptionLabel={(option) => `${option.region}`}
                            getOptionValue={(option) => `${option.region_id}`}
                            options={allRegion || []}
                            isClearable
                            isSearchable={true}
                            placeholder={`Select Region`}
                            classNamePrefix="select_kanakku"
                            defaultValue={''}
                            onChange={(value) => {
                              field.onChange(value)
                              setValue('city', '')
                            }}
                          />
                        )}
                      />
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-lg-12 col-sm-12">
                    <div className="form-group input_text border-remove dark_border_divs">
                      <label>City</label>
                      <Controller
                        name="city"
                        control={control}
                        render={({ field }) => (
                          <Select
                            {...field}
                            className={`react-selectcomponent form-control select-box-filed`}
                            getOptionLabel={(option) => `${option.city}`}
                            getOptionValue={(option) => `${option.city_id}`}
                            options={allCity || []}
                            isClearable
                            isSearchable={true}
                            placeholder={`Select City`}
                            classNamePrefix="select_kanakku"
                            defaultValue={''}
                          />
                        )}
                      />
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-lg-12 col-sm-12">
                    <div className="form-group input_text border-remove">
                      <label>Cleaning status</label>
                      {CleaningStatus?.map((status, index) => (
                        <Controller
                          key={`status-control-${index}`}
                          name={status?.key}
                          control={control}
                          // checked={true}
                          defaultValue={false}
                          render={({ field }) => (
                            <Form.Check
                              type="switch"
                              id={`custom-switch-${index}`}
                              label={`${status?.label}`}
                              {...field}
                              checked={field.value} // ensures checked state is bound to value
                            />
                          )}
                        />
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Filter Button */}
            <div className="filter-buttons">
              <button type="submit" className="d-inline-flex align-items-center justify-content-center btn w-100 sky_btn mb-1">
                Cleaning Count: {allOverview?.totalRecords || 0}
              </button>
              <button
                type="button"
                onClick={handleFilterclear}
                className="d-inline-flex align-items-center justify-content-center btn w-100 btn-primary"
              >
                Reset
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}
export default OverviewFilter
